module.exports = __webpack_public_path__ + "img/Step6.fc1ba26a.png";